import { render, staticRenderFns } from "./PowerLeakageTable.vue?vue&type=template&id=0873230d&scoped=true"
import script from "./PowerLeakageTable.vue?vue&type=script&lang=js"
export * from "./PowerLeakageTable.vue?vue&type=script&lang=js"
import style0 from "./PowerLeakageTable.vue?vue&type=style&index=0&id=0873230d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873230d",
  null
  
)

export default component.exports